/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The HouseManual model module.
 * @module model/HouseManual
 * @version 1.0.0
 */
export default class HouseManual {
  /**
   * Constructs a new <code>HouseManual</code>.
   * @alias module:model/HouseManual
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>HouseManual</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/HouseManual} obj Optional instance to populate.
   * @return {module:model/HouseManual} The populated <code>HouseManual</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HouseManual()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String')
      }
      if (data.hasOwnProperty('keywords')) {
        obj['keywords'] = ApiClient.convertToType(data['keywords'], 'String')
      }
      if (data.hasOwnProperty('manual_url')) {
        obj['manual_url'] = ApiClient.convertToType(data['manual_url'], 'Blob')
      }
      if (data.hasOwnProperty('position')) {
        obj['position'] = ApiClient.convertToType(data['position'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} title
   */
  title = undefined
  /**
   * @member {String} keywords
   */
  keywords = undefined
  /**
   * @member {Blob} manual_url
   */
  manual_url = undefined
  /**
   * @member {Number} position
   */
  position = undefined
}
